"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconImport = function SvgIconImport(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    fill: "currentColor",
    fillRule: "evenodd",
    viewBox: "0 0 48 48",
    "aria-label": "import icon"
  }, props), /*#__PURE__*/_react.default.createElement("title", null, 'Import Icon'), /*#__PURE__*/_react.default.createElement("path", {
    d: "M22 6v4.043c-6.773.976-12 6.801-12 13.84 0 7.72 6.28 14 14 14 7.039 0 12.864-5.227 13.84-12h4.043c-.996 8.999-8.618 16-17.883 16-9.941 0-18-8.059-18-18C6 14.618 13.001 6.996 22 6zm15.557 1.498l2.828 2.828-13.557 13.557H34v4H20v-14h4v7.172L37.557 7.498z"
  }));
};

var _default = SvgIconImport;
exports.default = _default;